import { Button, Container, Group, Paper, Stack, Text, Title } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Sticky from 'react-sticky-el';
import { Mail } from 'tabler-icons-react';
import useBoardHook from '../../utils/useBoardHook';
import useCheckAdminBoard from '../../utils/useCheckAdminBoard';
import useFirebaseFunction from '../../utils/useFirebaseFunction';
import useGetAdminDataBoard from '../../utils/useGetAdminDataBoard';
import BoardMenu from './BoardMenu';
import BoardMenuDelete from './BoardMenuDelete';
import CheckIcon from '../../assets/CheckIcon';
import PublishIcon from '../../assets/PublishIcon';
import PhotosIcon from '../../assets/PhotosIcon';
import ImageIcon from '../../assets/ImageIcon';

const BoardBar = ({disableFullScreen,isSearchLoading,setOpenModalPhotos,setOpenAdminPanel,setDisableFullScreen,onFaceIdClick,showOnlyMatching,saveQRCode,setPublishModal,selected,tabEvent,onHighlightsPhotos,highlightsPhotos}) => {

    let { subdomain } = useParams();

    const [delete_photos, isDeletePhotosLoading] = useFirebaseFunction("delete_photos", "europe-west1");
    
    const admin = useCheckAdminBoard(subdomain);
    const { getAdmin } = useGetAdminDataBoard(subdomain);
    const getDocumentBoard = useBoardHook(subdomain);

    const board = getDocumentBoard?.data?.id;

    const [selectMode, setSelectMode] = useState();

    const [shareDisabled,setShareDisabled] = useState(false);
    const [copied,setCopied] = useState(null);

    const published = getDocumentBoard?.data?.published;


    const handlerCopyShare = async (copyName) => {
        if(shareDisabled) return {};

        const dataStaging = {
            title: 'Picboard',
            text: `${getDocumentBoard?.data?.title}`,
            url:`https://picboard.ro/${getDocumentBoard?.data?.subdomain}`
        }


        if(navigator.canShare && navigator.canShare(dataStaging) !== undefined){
            await navigator.share(dataStaging).then(() => {
                setShareDisabled(true);
              }).catch((err) => {
            });
        } else {
            navigator.clipboard.writeText(dataStaging.url);
            setCopied(copyName);
            setShareDisabled(true);
        }
    }

    useEffect(()=>{
        if(copied){
            setTimeout(()=>{
                setCopied(null);
                setShareDisabled(false);
            },2500);
        }
    },[copied]);

    return (
        <Sticky stickyStyle={{zIndex: 999}}>
            {admin 
            ?  
                <Container pb={0} px={0} mx={0} fluid={true} id="contentGallery">
                    <Paper mx={0} >
                        <Group className='px-3 py-3' position="apart" >
                            <Stack style={{gap:'0px'}} spacing="xs" align="flex-start">
                                <Title style={{color:"#3C3C3C"}} order={4}>{getDocumentBoard?.data?.title}</Title>
                                <Text style={{color:"#3C3C3C"}} size="xs">{getAdmin?.firstName} {getAdmin?.lastName}</Text>
                            </Stack>
                            <Container px={0} mx={0}>
                                {!disableFullScreen ? 
                                    <BoardMenu 
                                        handlerCopyShare={handlerCopyShare}
                                        copied={copied}
                                        setSelectMode={setSelectMode}
                                        isDeletePhotosLoading={isDeletePhotosLoading}
                                        isSearchLoading={isSearchLoading}
                                        setOpenModalPhotos={setOpenModalPhotos}
                                        setOpenAdminPanel={setOpenAdminPanel}
                                        setDisableFullScreen={setDisableFullScreen}
                                        onFaceIdClick={onFaceIdClick}
                                        showOnlyMatching={showOnlyMatching}
                                        saveQRCode={saveQRCode}
                                        setPublishModal={setPublishModal}
                                        onHighlightsPhotos={onHighlightsPhotos}
                                        highlightsPhotos={highlightsPhotos}
                                    />
                                : 
                                    <BoardMenuDelete 
                                        selectMode={selectMode}
                                        selected={selected}
                                        isDeletePhotosLoading={isDeletePhotosLoading}
                                        setDisableFullScreen={setDisableFullScreen}
                                        delete_photos={delete_photos}
                                        board={board}
                                    /> 
                                }
                            </Container>
                            <Container mx={0} px={0} className="hidden lg:block">
                                {!published ? 
                                    <Button size="sm" className="btnPublica" onClick={() => setPublishModal(true)} leftIcon={<PublishIcon width={15} height={15} />}>
                                        Publică
                                    </Button>
                                :
                                    <Button size="sm" color="green" className="pointer-events-none" classNames="btnPublica" leftIcon={<CheckIcon />}>
                                        Publicat
                                    </Button>
                                }
                            </Container>
                        </Group>
                    </Paper>
                </Container>
            : 
                (board && !admin && !published) ?
                <div className="h-[4px]"></div>
                :
                <>
                    <div className="block md:hidden h-[4px] bg-white w-full"></div>

                    <div className="hidden md:block px-3 pt-2 bg-white w-full">
                        <div className="flex items-center justify-around md:justify-center">
                            <div onClick={() => tabEvent('all')} className={`flex items-center cursor-pointer border-b-4 px-2 md:px-3 py-2 ${!showOnlyMatching ? 'border-[#3c3c3c]' : 'border-transparent opacity-80'} gap-x-2`}>
                                <ImageIcon width={28} height={28} />
                                <p className="text-[#3c3c3c] text-sm md:text-sm font-[500]">Fotografii publice</p>
                            </div>
                            <div onClick={() => tabEvent('selfie')} className={`flex items-center cursor-pointer border-b-4 px-2 md:px-3 py-2 ${showOnlyMatching ? 'border-[#3c3c3c]' : 'border-transparent opacity-80'} gap-x-2`}>
                                <PhotosIcon width={28} height={28} />
                                <p className="text-[#3c3c3c] text-sm md:text-sm font-[500]">Fotografii private</p>
                            </div>
                        </div>
                    </div>
                </>       
            }
        </Sticky>
    )
}

export default BoardBar